import { gql } from '@apollo/client'

export const ScoreGridsOverviewFragment = gql`
  fragment ScoreGridsOverviewFragment on ScoreGridsOverviewDTO {
    id
    lastAppraisalDate
    lastAppraisalEmplPrepDate
    priorAppraisalDate
    scoreGoals {
      id
      viewId
      employeeEvaluation
      resultEvaluation
      lastResultEvaluation
    }
  }
`
